/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);

function setRealVh() {
  document.documentElement.style.setProperty(
    '--real-vh',
    `${window.innerHeight * 0.01}px`,
  );
}
setRealVh();
window.addEventListener('resize', setRealVh);
window.addEventListener('orientationchange', () => {
  setTimeout(setRealVh, 300);
});
